module.exports = __webpack_public_path__ + "img/hereWeGo-logo.ebcce083.png";